import React from 'react'
import { Col as ReactstrapCol, ColProps } from 'reactstrap'

export const Col: React.FC<ColProps> = props => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return <ReactstrapCol {...(props as any)} />
}
